import { AdvancedFilterProps } from './AdvancedFilter'
import { CheckBoxTemplate } from './componentsTemplates/CheckboxTemplate'
import { DatePickerTemplate } from './componentsTemplates/DatePickerTemplate'
import { TextInputTemplate } from './componentsTemplates/TextInputTemplate'
import { UserSelectorTemplate } from './componentsTemplates/UserSelectorTemplate'
import { TemplateType } from './types'

export const transformers: Record<keyof TemplateType, (param: TemplateType[keyof TemplateType]['content']) => string> = {
  checkbox: (params: CheckBoxTemplate[]) => {
    return params
      .filter(f => f.isChecked)
      .map(m => m.value)
      .toString()
  },
  text: (params: TextInputTemplate[]) => {
    return params.map(m => m.value).toString()
  },
  datePicker: (params: DatePickerTemplate[]) => {
    return params
      .filter(f => f.value[0] || f.value[1])
      .map(m => m.value.toString())
      .toString()
  },
  usersSelector: (params: UserSelectorTemplate[]) => {
    return JSON.stringify(params.map(m => m.selectedIds).flat())
  }
}

const checkboxReseter = (state: CheckBoxTemplate): CheckBoxTemplate => {
  return { ...state, isChecked: false }
}
const textInputReseter = (state: TextInputTemplate): TextInputTemplate => {
  return { ...state, value: '' }
}
const datePickerReseter = (state: DatePickerTemplate): DatePickerTemplate => {
  return { ...state, value: [null, null] }
}
const userSelectorReseter = (state: UserSelectorTemplate): UserSelectorTemplate => {
  return { ...state, selectedIds: [] }
}

const reseter: Record<
  keyof TemplateType,
  (param: TemplateType[keyof TemplateType]['content']) => TemplateType[keyof TemplateType]['content']
> = {
  checkbox: (params: CheckBoxTemplate[]) => {
    return params.map(m => checkboxReseter(m))
  },
  text: (params: TextInputTemplate[]) => {
    return params.map(m => textInputReseter(m))
  },
  datePicker: (params: DatePickerTemplate[]) => {
    return params.map(m => datePickerReseter(m))
  },
  usersSelector: (params: UserSelectorTemplate[]) => {
    return params.map(m => userSelectorReseter(m))
  }
}
export const resetAll = (content: AdvancedFilterProps['content']) => {
  const state = [...content]
  state.forEach((f, i) => {
    state[i].content = reseter[f.type](f.content)
  })
  return state
}
